'use strict';

var angular = require('angular');
var interact;
try {
  interact = require('interact.js');
} catch (e) {
  interact = null;
}

angular
  .module('mwl.calendar')
  .constant('interact', interact);



/*****************
 ** WEBPACK FOOTER
 ** ./src/services/interact.js
 ** module id = 26
 ** module chunks = 0
 **/